var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panorama-custom-table-cell" }, [
    _c("span", { staticClass: "property-a" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.customParamsRowValueFormatter(
              _vm.consumerBillItem,
              _vm.monthIndex,
              _vm.propertyNameA
            )
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v("|")]),
    _vm._v(" "),
    _c("span", { staticClass: "property-b" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.customParamsRowValueFormatter(
              _vm.consumerBillItem,
              _vm.monthIndex,
              _vm.propertyNameB
            )
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v("|")]),
    _vm._v(" "),
    _c("span", { staticClass: "property-c" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.customParamsRowValueFormatter(
              _vm.consumerBillItem,
              _vm.monthIndex,
              _vm.propertyNameC
            )
          ) +
          "\n  "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }